import { z } from 'zod';

import { IdpPdfLanguage } from '@/common/graphql';

// 061-idp-pdf-signing: the dialog's actual initial value is set per-IDP from
// `detectedPdfLanguage` via useForm's defaultValues (IdpGeneratePdfDialog.tsx) - EN here is only
// the static fallback `.parse({})` itself produces, since a Zod schema has no access to runtime data.
export const IdpPdfGenerationFormData = z.object({
  language: z.nativeEnum(IdpPdfLanguage).default(IdpPdfLanguage.En),
});
export type IdpPdfGenerationFormDataType = z.infer<typeof IdpPdfGenerationFormData>;
